/* ============================================================
   COUVRE-PLANCHERS LOISELLE — interactivity
   - Hero carousel (3 slides, auto-rotate, arrows + dots, swipe)
   - Scroll-reveal animations
   - Marquee pause on hover
   - Smooth-scroll for in-page anchors
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  /* ===== COOKIE BANNER ===== */
  const cookieBanner = document.querySelector('.cookie-banner');
  if (cookieBanner) {
    const COOKIE_KEY = 'loiselle_cookie_consent';
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      setTimeout(() => {
        cookieBanner.classList.add('is-visible');
        cookieBanner.setAttribute('aria-hidden', 'false');
      }, 1500);
    }
    cookieBanner.querySelectorAll('[data-cookie]').forEach(btn => {
      btn.addEventListener('click', () => {
        const choice = btn.getAttribute('data-cookie');
        localStorage.setItem(COOKIE_KEY, choice);
        cookieBanner.classList.remove('is-visible');
        cookieBanner.setAttribute('aria-hidden', 'true');
      });
    });
  }

  /* ===== MOBILE DRAWER SERVICES SUBLIST TOGGLE ===== */
  document.querySelectorAll('.mm-section-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const sublist = toggle.nextElementSibling;
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      sublist.classList.toggle('is-open');
    });
  });

  /* ===== HAMBURGER / MOBILE DRAWER ===== */
  const hamburger = document.querySelector('.hamburger');
  const drawer = document.querySelector('.mobile-menu');
  const backdrop = document.querySelector('.mobile-menu-backdrop');
  if (hamburger && drawer) {
    const closeMenu = () => {
      document.body.classList.remove('menu-open');
      hamburger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
    };
    const openMenu = () => {
      document.body.classList.add('menu-open');
      hamburger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
    };
    hamburger.addEventListener('click', () => {
      if (document.body.classList.contains('menu-open')) closeMenu(); else openMenu();
    });
    backdrop.addEventListener('click', closeMenu);
    const closeBtn = drawer.querySelector('.mm-close');
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
  }

  /* ===== HERO CAROUSEL ===== */
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.carousel-dots .dot');
  const prev = document.querySelector('.carousel-prev');
  const next = document.querySelector('.carousel-next');
  const hero = document.querySelector('.hero');

  /* Only initialise the hero carousel if there are at least 2 slides AND controls exist */
  if (slides.length > 1 && prev && next && dots.length > 0) {
    let index = 0;
    let auto;

    function go(to) {
      slides[index].classList.remove('is-active');
      dots[index].classList.remove('is-active');
      dots[index].setAttribute('aria-selected', 'false');
      index = (to + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      dots[index].classList.add('is-active');
      dots[index].setAttribute('aria-selected', 'true');
    }
    function nextSlide() { go(index + 1); }
    function prevSlide() { go(index - 1); }
    function start() { stop(); auto = setInterval(nextSlide, 5000); }
    function stop()  { if (auto) clearInterval(auto); }

    next.addEventListener('click', () => { nextSlide(); start(); });
    prev.addEventListener('click', () => { prevSlide(); start(); });
    dots.forEach((d, i) => d.addEventListener('click', () => { go(i); start(); }));

    if (hero) {
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      /* Touch swipe */
      let startX = 0, deltaX = 0;
      hero.addEventListener('touchstart', e => { startX = e.touches[0].clientX; stop(); }, { passive: true });
      hero.addEventListener('touchmove',  e => { deltaX = e.touches[0].clientX - startX; }, { passive: true });
      hero.addEventListener('touchend', () => {
        if (deltaX < -50) nextSlide();
        else if (deltaX > 50) prevSlide();
        deltaX = 0;
        start();
      });
    }

    /* Keyboard support */
    document.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  { prevSlide(); start(); }
      if (e.key === 'ArrowRight') { nextSlide(); start(); }
    });

    start();
  }

  /* ===== SCROLL REVEAL (content always visible; just mark as seen on view) ===== */
  document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible'));

  /* ===== CINEMATIC SCROLL REVEAL — pinned image zoom + headline swap ===== */
  const cine = document.querySelector('.cine');
  if (cine) {
    const bg1 = cine.querySelector('.cine-bg--1');
    const bg2 = cine.querySelector('.cine-bg--2');
    const l1  = cine.querySelector('.cine-line--1');
    const l2  = cine.querySelector('.cine-line--2');
    const bar = cine.querySelector('.cine-progress-bar');
    const clamp = (v, a, b) => Math.min(Math.max(v, a), b);
    let ticking = false;
    function cineUpdate() {
      const rect = cine.getBoundingClientRect();
      const total = cine.offsetHeight - window.innerHeight;
      const p = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
      // both backgrounds slowly zoom out (1.18 -> 1.0) as you scroll through
      const scale = 'scale(' + (1.18 - p * 0.18).toFixed(4) + ')';
      // image 1 fades out, image 2 fades in — synced with the headline swap
      const imgO1 = 1 - clamp((p - 0.34) / 0.18, 0, 1);
      const imgO2 = clamp((p - 0.44) / 0.18, 0, 1);
      if (bg1) { bg1.style.transform = scale; bg1.style.opacity = imgO1.toFixed(3); }
      if (bg2) { bg2.style.transform = scale; bg2.style.opacity = imgO2.toFixed(3); }
      // headline 1 fades out (0.34 -> 0.50), headline 2 fades in (0.46 -> 0.62)
      const o1 = 1 - clamp((p - 0.34) / 0.16, 0, 1);
      const o2 = clamp((p - 0.46) / 0.16, 0, 1);
      if (l1) { l1.style.opacity = o1.toFixed(3); l1.style.transform = 'translateY(' + (p * -26).toFixed(1) + 'px)'; }
      if (l2) { l2.style.opacity = o2.toFixed(3); l2.style.transform = 'translateY(' + ((1 - p) * 26).toFixed(1) + 'px)'; }
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
      ticking = false;
    }
    function onCineScroll() { if (!ticking) { requestAnimationFrame(cineUpdate); ticking = true; } }
    window.addEventListener('scroll', onCineScroll, { passive: true });
    window.addEventListener('resize', onCineScroll);
    cineUpdate();
  }

  /* ===== STUDIO TOUR — scale-up reveal on scroll into view ===== */
  const studioSection = document.querySelector('.video-section');
  if (studioSection && 'IntersectionObserver' in window) {
    const studioObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          studioObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
    studioObs.observe(studioSection);
    // Fallback: if observer never fires (small viewport, immediate visibility), trigger after 600ms
    setTimeout(() => studioSection.classList.add('in-view'), 1500);
  } else if (studioSection) {
    studioSection.classList.add('in-view');
  }

  /* ===== MARQUEE PAUSE ON HOVER ===== */
  const track = document.querySelector('.marquee-track');
  if (track) {
    track.parentElement.addEventListener('mouseenter', () => { track.style.animationPlayState = 'paused'; });
    track.parentElement.addEventListener('mouseleave', () => { track.style.animationPlayState = 'running'; });
  }

  /* ===== SMART STICKY HEADER (show on scroll up, hide on scroll down) ===== */
  (function setupStickyNav() {
    // Use the server-rendered sticky nav from header.liquid — it already has
    // the correct Shopify asset URLs (logo-dark via asset_url), dynamic menu
    // links (routes), and active-link state. Do NOT rebuild it in JS (that
    // produced broken relative paths like assets/logo-dark.png + about.html).
    const sticky = document.querySelector('.sticky-nav');
    if (!sticky) return;

    // Wire mobile hamburger on sticky nav to existing drawer
    const stickyBurger = sticky.querySelector('.sticky-hamburger');
    if (stickyBurger) {
      stickyBurger.addEventListener('click', () => {
        document.body.classList.toggle('menu-open');
        const drawer = document.querySelector('.mobile-menu');
        if (drawer) drawer.setAttribute('aria-hidden', document.body.classList.contains('menu-open') ? 'false' : 'true');
      });
    }

    // Smart show/hide on scroll
    let lastScroll = window.scrollY;
    const SHOW_AFTER = 600; // px scrolled past hero before sticky shows
    const SCROLL_DELTA = 5; // ignore tiny scroll jitter

    function updateSticky() {
      const y = window.scrollY;
      const diff = y - lastScroll;

      if (y < SHOW_AFTER) {
        sticky.classList.remove('is-visible', 'is-hidden');
      } else if (Math.abs(diff) > SCROLL_DELTA) {
        if (diff > 0) {
          // scrolling DOWN: hide
          sticky.classList.add('is-hidden');
          sticky.classList.remove('is-visible');
        } else {
          // scrolling UP: show
          sticky.classList.add('is-visible');
          sticky.classList.remove('is-hidden');
        }
      }
      lastScroll = y;
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
  })();

  /* ===== STAT COUNT-UP ON FIRST VIEW ===== */
  const statNums = document.querySelectorAll('.stat-num');
  const statsObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const raw = el.textContent.trim();
      // Only animate purely numeric leading parts
      const match = raw.match(/^(\d+(?:\.\d+)?)([^\d].*)?$/);
      if (!match) return;
      const target = parseFloat(match[1]);
      const suffix = match[2] || '';
      const isFloat = match[1].includes('.');
      const duration = 1400;
      const startT = performance.now();
      function tick(now) {
        const p = Math.min(1, (now - startT) / duration);
        const eased = 1 - Math.pow(1 - p, 3);
        const v = isFloat ? (target * eased).toFixed(1) : Math.floor(target * eased);
        el.textContent = v + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      statsObserver.unobserve(el);
    });
  }, { threshold: 0.4 });
  statNums.forEach(s => statsObserver.observe(s));

  /* ===== TESTIMONIALS CAROUSEL — 3-up auto-scroll ===== */
  const tCarousel = document.querySelector('.t-carousel');
  if (tCarousel) {
    const track = tCarousel.querySelector('.t-track');
    const cards = [...track.children];
    const dotsWrap = tCarousel.querySelector('.t-dots');
    const tPrev = tCarousel.querySelector('.t-prev');
    const tNext = tCarousel.querySelector('.t-next');

    function getPerView() {
      const w = window.innerWidth;
      if (w <= 768) return 1;
      if (w <= 1024) return 2;
      return 3;
    }

    let perView = getPerView();
    let page = 0;
    let pages = Math.max(1, Math.ceil(cards.length - perView + 1));
    let tAuto;

    function buildDots() {
      dotsWrap.innerHTML = '';
      pages = Math.max(1, cards.length - perView + 1);
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', `Testimonials page ${i + 1}`);
        if (i === 0) b.classList.add('is-active');
        b.addEventListener('click', () => { goTo(i); resetAuto(); });
        dotsWrap.appendChild(b);
      }
    }

    function goTo(p) {
      pages = Math.max(1, cards.length - perView + 1);
      page = ((p % pages) + pages) % pages;
      const card = cards[0];
      const cardW = card.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const offset = (cardW + gap) * page;
      track.style.transform = `translateX(-${offset}px)`;
      [...dotsWrap.children].forEach((d, i) => d.classList.toggle('is-active', i === page));
    }
    function tNextSlide() { goTo(page + 1); }
    function tPrevSlide() { goTo(page - 1); }
    function startAuto() { stopAuto(); tAuto = setInterval(tNextSlide, 3000); }
    function stopAuto() { if (tAuto) clearInterval(tAuto); }
    function resetAuto() { startAuto(); }

    tNext.addEventListener('click', () => { tNextSlide(); resetAuto(); });
    tPrev.addEventListener('click', () => { tPrevSlide(); resetAuto(); });

    // Pause when browser tab is hidden, resume when visible (no hover-pause — keep rotating)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAuto();
      else startAuto();
    });

    /* Touch */
    let tx = 0, td = 0;
    track.addEventListener('touchstart', e => { tx = e.touches[0].clientX; stopAuto(); }, { passive: true });
    track.addEventListener('touchmove',  e => { td = e.touches[0].clientX - tx; }, { passive: true });
    track.addEventListener('touchend', () => {
      if (td < -40) tNextSlide(); else if (td > 40) tPrevSlide();
      td = 0; startAuto();
    });

    /* Rebuild on resize */
    let resizeT;
    window.addEventListener('resize', () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(() => {
        const newPerView = getPerView();
        if (newPerView !== perView) {
          perView = newPerView;
          page = 0;
          buildDots();
        }
        goTo(page);
      }, 150);
    });

    buildDots();
    goTo(0);
    startAuto();
  }

  /* ===== PROJECTS FILTERS + PAGINATION ===== */
  const projSection = document.querySelector('.proj-section');
  if (projSection) {
    const filters = Array.from(projSection.querySelectorAll('.proj-filter'));
    const cards = Array.from(projSection.querySelectorAll('.proj-card'));
    const empty = projSection.querySelector('.proj-empty');
    const pageNumbersWrap = projSection.querySelector('.proj-page-numbers');
    const prevBtn = projSection.querySelector('.proj-page-prev');
    const nextBtn = projSection.querySelector('.proj-page-next');
    const PER_PAGE = parseInt(projSection.getAttribute('data-per-page'), 10) || 6;

    // Restore the active category + page from the URL, so opening a project and pressing
    // Back returns to the same filtered view instead of resetting to "All".
    const validFilters = filters.map(f => f.getAttribute('data-filter') || 'all');
    const initParams = new URLSearchParams(window.location.search);
    let currentFilter = initParams.get('category') || 'all';
    if (validFilters.indexOf(currentFilter) === -1) currentFilter = 'all';
    let currentPage = parseInt(initParams.get('ppage'), 10);
    if (!currentPage || currentPage < 1) currentPage = 1;
    filters.forEach(b => b.classList.toggle('is-active', (b.getAttribute('data-filter') || 'all') === currentFilter));

    // Mirror the current filter/page into the URL (preserving other params like preview_theme_id).
    // replaceState keeps a single history entry so Back leaves the page rather than stepping filters.
    const syncUrl = () => {
      const p = new URLSearchParams(window.location.search);
      if (currentFilter && currentFilter !== 'all') { p.set('category', currentFilter); } else { p.delete('category'); }
      if (currentPage > 1) { p.set('ppage', String(currentPage)); } else { p.delete('ppage'); }
      const qs = p.toString();
      try { window.history.replaceState(window.history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash); } catch (e) {}
    };

    const masonry = projSection.querySelector('.proj-masonry');
    // A project can sit in a different position per view. data-order-<view> holds the manual
    // position (lower = first); blank falls back to the default date order via a stable sort.
    const orderVal = (card) => { const v = parseInt(card.getAttribute('data-order-' + currentFilter), 10); return isNaN(v) ? Infinity : v; };
    const getVisibleCards = () => {
      const base = currentFilter === 'all'
        ? cards.slice()
        : cards.filter(c => (c.getAttribute('data-cats') || '').split(/\s+/).includes(currentFilter));
      return base
        .map((c, i) => [c, i])
        .sort((a, b) => { const d = orderVal(a[0]) - orderVal(b[0]); return d !== 0 ? d : a[1] - b[1]; })
        .map(pair => pair[0]);
    };

    const renderPagination = (totalPages) => {
      if (!pageNumbersWrap) return;
      pageNumbersWrap.innerHTML = '';
      if (totalPages <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }
      if (prevBtn) prevBtn.style.display = '';
      if (nextBtn) nextBtn.style.display = '';
      const makeBtn = (n) => {
        const b = document.createElement('button');
        b.className = 'proj-page-num' + (n === currentPage ? ' is-active' : '');
        b.textContent = String(n);
        b.setAttribute('aria-label', `Page ${n}`);
        b.addEventListener('click', () => { currentPage = n; render(); });
        return b;
      };
      const makeEllipsis = () => {
        const s = document.createElement('span');
        s.className = 'proj-page-ellipsis';
        s.textContent = '…';
        return s;
      };
      const pages = [];
      if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        if (currentPage > 3) pages.push('e');
        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);
        for (let i = start; i <= end; i++) pages.push(i);
        if (currentPage < totalPages - 2) pages.push('e');
        pages.push(totalPages);
      }
      pages.forEach(p => pageNumbersWrap.appendChild(p === 'e' ? makeEllipsis() : makeBtn(p)));
      if (prevBtn) prevBtn.disabled = currentPage === 1;
      if (nextBtn) nextBtn.disabled = currentPage === totalPages;
    };

    const render = () => {
      const visible = getVisibleCards();
      const totalPages = Math.max(1, Math.ceil(visible.length / PER_PAGE));
      if (currentPage > totalPages) currentPage = totalPages;
      cards.forEach(c => { c.style.display = 'none'; });
      const startIdx = (currentPage - 1) * PER_PAGE;
      visible.slice(startIdx, startIdx + PER_PAGE).forEach(c => { c.style.display = ''; if (masonry) masonry.appendChild(c); });
      if (empty) empty.hidden = visible.length > 0;
      renderPagination(totalPages);
      if (window._projInited) {
        const filterBar = projSection.querySelector('.proj-filters');
        if (filterBar) filterBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      syncUrl();
    };

    filters.forEach(btn => {
      btn.addEventListener('click', () => {
        filters.forEach(b => b.classList.toggle('is-active', b === btn));
        currentFilter = btn.getAttribute('data-filter') || 'all';
        currentPage = 1;
        render();
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', () => { if (currentPage > 1) { currentPage--; render(); } });
    if (nextBtn) nextBtn.addEventListener('click', () => {
      const totalPages = Math.max(1, Math.ceil(getVisibleCards().length / PER_PAGE));
      if (currentPage < totalPages) { currentPage++; render(); }
    });

    render();
    window._projInited = true;
  }

  /* ===== PROJECT CARD PHOTO ARROWS (manual) ===== */
  document.querySelectorAll('.proj-card').forEach(card => {
    const frames = Array.from(card.querySelectorAll('.proj-frame'));
    const dots = Array.from(card.querySelectorAll('.proj-dot'));
    const prev = card.querySelector('.proj-arrow--prev');
    const next = card.querySelector('.proj-arrow--next');
    if (frames.length < 2) {
      if (prev) prev.remove();
      if (next) next.remove();
      return;
    }
    let idx = 0;
    const go = (n) => {
      frames[idx].classList.remove('is-active');
      if (dots[idx]) dots[idx].classList.remove('is-active');
      idx = (n + frames.length) % frames.length;
      frames[idx].classList.add('is-active');
      if (dots[idx]) dots[idx].classList.add('is-active');
    };
    // preventDefault/stopPropagation so the card link doesn't open while paging photos
    const nav = (dir) => (e) => { e.preventDefault(); e.stopPropagation(); go(idx + dir); };
    if (prev) prev.addEventListener('click', nav(-1));
    if (next) next.addEventListener('click', nav(1));
  });

  /* ===== PROJECT DETAIL GALLERY LIGHTBOX ===== */
  const pggGrid = document.getElementById('ProjGallery');
  const pggLb = document.getElementById('ProjLightbox');
  if (pggGrid && pggLb) {
    const items = Array.from(pggGrid.querySelectorAll('.pgg-item'));
    const lbImg = pggLb.querySelector('.pgg-lb-img');
    const lbCount = pggLb.querySelector('.pgg-lb-count');
    let cur = 0;
    const show = (i) => {
      cur = (i + items.length) % items.length;
      lbImg.src = items[cur].getAttribute('data-full');
      const innerImg = items[cur].querySelector('img');
      lbImg.alt = innerImg ? innerImg.alt : '';
      if (lbCount) lbCount.textContent = (cur + 1) + ' / ' + items.length;
    };
    const open = (i) => { show(i); pggLb.hidden = false; document.body.style.overflow = 'hidden'; };
    const close = () => { pggLb.hidden = true; document.body.style.overflow = ''; };
    items.forEach((it, i) => it.addEventListener('click', () => open(i)));
    pggLb.querySelector('.pgg-lb-close').addEventListener('click', close);
    pggLb.querySelector('.pgg-lb-prev').addEventListener('click', (e) => { e.stopPropagation(); show(cur - 1); });
    pggLb.querySelector('.pgg-lb-next').addEventListener('click', (e) => { e.stopPropagation(); show(cur + 1); });
    pggLb.addEventListener('click', (e) => { if (e.target === pggLb) close(); });
    document.addEventListener('keydown', (e) => {
      if (pggLb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === 'ArrowRight') show(cur + 1);
    });
  }

  /* ===== CATEGORY ROOM TABS + CAROUSEL ===== */
  document.querySelectorAll('.lp-carousel-section').forEach(section => {
    const tabs = Array.from(section.querySelectorAll('.lp-tab'));
    const panels = Array.from(section.querySelectorAll('.lp-carousel'));

    const setupCarousel = (panel) => {
      const track = panel.querySelector('.lp-carousel-track');
      const slides = Array.from(panel.querySelectorAll('.lp-slide'));
      const prev = panel.querySelector('.lp-car-prev');
      const next = panel.querySelector('.lp-car-next');
      const dots = Array.from(panel.querySelectorAll('.lp-car-dot'));
      const curEl = panel.querySelector('.lp-car-cur');
      if (!track || slides.length < 2) return;

      const hasOverflow = () => track.scrollWidth > track.clientWidth + 2;
      panel._applyStatic = () => { panel.classList.toggle('lp-static', !hasOverflow()); };

      const step = () => {
        if (slides[1]) return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
        return slides[0].getBoundingClientRect().width || track.clientWidth || 1;
      };
      const maxScroll = () => track.scrollWidth - track.clientWidth;
      const current = () => Math.round(track.scrollLeft / (step() || 1));
      const atEnd = () => track.scrollLeft >= maxScroll() - 2;
      const goTo = (i) => { const n = Math.max(0, Math.min(i, slides.length - 1)); track.scrollTo({ left: n * step(), behavior: 'smooth' }); };

      if (prev) prev.addEventListener('click', () => { if (track.scrollLeft <= 2) goTo(slides.length - 1); else goTo(current() - 1); });
      if (next) next.addEventListener('click', () => { if (atEnd()) goTo(0); else goTo(current() + 1); });
      dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));

      let raf;
      const update = () => {
        const c = current();
        dots.forEach((d, i) => d.classList.toggle('is-active', i === c));
        if (curEl) curEl.textContent = String(Math.min(c + 1, slides.length));
      };
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); });
      update();

      // gentle autoplay, paused on hover / when panel hidden
      let timer = null;
      panel._start = () => { if (timer || !hasOverflow()) return; timer = setInterval(() => { if (atEnd()) goTo(0); else goTo(current() + 1); }, 2000); };
      panel._stop = () => { clearInterval(timer); timer = null; };
      panel.addEventListener('mouseenter', () => panel._stop());
      panel.addEventListener('mouseleave', () => { if (panel.classList.contains('is-active')) panel._start(); });
    };

    panels.forEach(setupCarousel);

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const idx = tab.getAttribute('data-tab');
        tabs.forEach(t => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(p => {
          const on = p.getAttribute('data-panel') === idx;
          p.classList.toggle('is-active', on);
          if (p._stop) p._stop();
          if (on) { if (p._applyStatic) p._applyStatic(); if (p._start) p._start(); }
        });
      });
    });

    const first = panels.find(p => p.classList.contains('is-active'));
    if (first) { if (first._applyStatic) first._applyStatic(); if (first._start) first._start(); }

    let rt;
    window.addEventListener('resize', () => {
      clearTimeout(rt);
      rt = setTimeout(() => { const a = panels.find(p => p.classList.contains('is-active')); if (a && a._applyStatic) a._applyStatic(); }, 200);
    });

    // Click a carousel photo to open it full-size in a lightbox (navigates that room's photos)
    const lb = section.querySelector('.lp-lightbox');
    if (lb) {
      const lbImg = lb.querySelector('.lp-lb-img');
      const lbCount = lb.querySelector('.lp-lb-count');
      let list = [], idx = 0;
      const show = (i) => {
        idx = (i + list.length) % list.length;
        lbImg.src = list[idx].full;
        lbImg.alt = list[idx].alt || '';
        if (lbCount) lbCount.textContent = (idx + 1) + ' / ' + list.length;
      };
      const open = (imgs, i) => { list = imgs; show(i); lb.hidden = false; document.body.style.overflow = 'hidden'; };
      const close = () => { lb.hidden = true; document.body.style.overflow = ''; };
      section.querySelectorAll('.lp-slide img').forEach(im => {
        im.addEventListener('click', () => {
          const panel = im.closest('.lp-carousel');
          const imEls = Array.from(panel.querySelectorAll('.lp-slide img'));
          open(imEls.map(x => ({ full: x.getAttribute('data-full') || x.src, alt: x.alt })), imEls.indexOf(im));
        });
      });
      lb.querySelector('.lp-lb-close').addEventListener('click', close);
      lb.querySelector('.lp-lb-prev').addEventListener('click', (e) => { e.stopPropagation(); show(idx - 1); });
      lb.querySelector('.lp-lb-next').addEventListener('click', (e) => { e.stopPropagation(); show(idx + 1); });
      lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
      document.addEventListener('keydown', (e) => {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === 'ArrowRight') show(idx + 1);
      });
    }
  });

  /* ===== PLAY BUTTON — opens the presentation video in a lightbox ===== */
  const playBtn = document.querySelector('.play-btn');
  const videoLb = document.querySelector('[data-video-lb]');
  if (playBtn && videoLb) {
    const media = videoLb.querySelector('.video-lb-media');
    const closeVlb = () => {
      videoLb.hidden = true;
      document.body.style.overflow = '';
      try { media.pause(); } catch (e) {}
    };
    playBtn.addEventListener('click', () => {
      videoLb.hidden = false;
      document.body.style.overflow = 'hidden';
      try { media.currentTime = 0; } catch (e) {}
      const p = media.play();
      if (p && p.catch) p.catch(() => {});
    });
    videoLb.querySelector('.video-lb-close').addEventListener('click', closeVlb);
    videoLb.addEventListener('click', (e) => { if (e.target === videoLb) closeVlb(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !videoLb.hidden) closeVlb(); });
  } else if (playBtn) {
    playBtn.addEventListener('click', () => {
      playBtn.classList.add('is-playing');
      playBtn.animate(
        [{ transform: 'translate(-50%,-50%) scale(1)' }, { transform: 'translate(-50%,-50%) scale(1.4)', opacity: 0 }],
        { duration: 500, easing: 'ease-out' }
      );
    });
  }

  /* ===== PARTNER BRANDS MARQUEE — auto-scroll + grab/drag to browse ===== */
  (function () {
    const marquee = document.querySelector('.brand-marquee');
    if (!marquee) return;
    const rowEls = Array.from(marquee.querySelectorAll('.brand-row'));
    if (!rowEls.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const rows = rowEls.map((rowEl, i) => {
      const track = rowEl.querySelector('.brand-track');
      track.style.animation = 'none'; track.style.willChange = 'transform';
      return { rowEl, track, x: 0, dir: i === 0 ? 1 : -1, speed: i === 0 ? 0.35 : 0.30, half: 0, paused: false, dragging: false, startX: 0, startX0: 0, moved: 0 };
    });
    const measure = () => rows.forEach(r => { r.half = r.track.scrollWidth / 2; });
    measure();
    window.addEventListener('resize', measure);
    const wrap = (r) => { if (r.half > 0) { while (r.x <= -r.half) r.x += r.half; while (r.x > 0) r.x -= r.half; } };
    const apply = (r) => { r.track.style.transform = 'translateX(' + r.x + 'px)'; };
    function frame() {
      rows.forEach(r => { if (!r.dragging && !r.paused && !reduce) { r.x -= r.dir * r.speed; wrap(r); apply(r); } });
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    const px = (e) => (e.touches ? e.touches[0].clientX : e.clientX);
    let active = null;
    rows.forEach(r => {
      r.rowEl.addEventListener('mouseenter', () => { r.paused = true; });
      r.rowEl.addEventListener('mouseleave', () => { if (!r.dragging) r.paused = false; });
      const start = (e) => { r.dragging = true; r.moved = 0; r.startX = px(e); r.startX0 = r.x; r.paused = true; active = r; };
      r.rowEl.addEventListener('mousedown', (e) => { e.preventDefault(); start(e); });
      r.rowEl.addEventListener('touchstart', start, { passive: true });
      r.rowEl.addEventListener('click', (e) => { if (r.moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
    const moveH = (e) => {
      if (!active) return;
      const r = active; const dx = px(e) - r.startX; if (Math.abs(dx) > r.moved) r.moved = Math.abs(dx);
      if (r.moved > 6) r.rowEl.classList.add('is-grabbing');
      r.x = r.startX0 + dx; wrap(r); apply(r);
      if (e.cancelable && e.touches && Math.abs(dx) > 6) e.preventDefault();
    };
    const up = () => { if (!active) return; const r = active; r.dragging = false; r.paused = false; r.rowEl.classList.remove('is-grabbing'); active = null; };
    window.addEventListener('mousemove', moveH);
    window.addEventListener('mouseup', up);
    window.addEventListener('touchmove', moveH, { passive: false });
    window.addEventListener('touchend', up);
  })();

  /* ===== FAQ ACCORDION — single-open behavior ===== */
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        faqItems.forEach(other => {
          if (other !== item && other.open) other.open = false;
        });
      }
    });
  });

  /* ===== BEFORE / AFTER PROJECT TABS ===== */
  const baTabs = document.querySelectorAll('.ba-tab');
  const baSlides = document.querySelectorAll('.ba-slide');
  baTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const idx = tab.getAttribute('data-project');
      baTabs.forEach(t => t.classList.toggle('is-active', t === tab));
      baSlides.forEach(s => s.classList.toggle('is-active', s.getAttribute('data-slide') === idx));
    });
  });

  /* ===== BEFORE / AFTER SLIDER ===== */
  document.querySelectorAll('[data-compare]').forEach(box => {
    const afterWrap = box.querySelector('.ba-after-wrap');
    const beforeWrap = box.querySelector('.ba-before-wrap');
    const divider = box.querySelector('.ba-divider');
    const range = box.querySelector('.ba-range');
    if (!afterWrap || !beforeWrap || !divider || !range) return;
    const set = (pct) => {
      pct = Math.max(0, Math.min(100, pct));
      afterWrap.style.clipPath = `inset(0 0 0 ${pct}%)`;
      beforeWrap.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      divider.style.left = pct + '%';
      range.value = pct;
    };
    range.addEventListener('input', e => set(parseFloat(e.target.value)));
    // Click + drag on the image area updates the slider
    const fromX = (clientX) => {
      const r = box.getBoundingClientRect();
      return ((clientX - r.left) / r.width) * 100;
    };
    box.addEventListener('pointerdown', e => {
      set(fromX(e.clientX));
      const move = ev => set(fromX(ev.clientX));
      const up = () => {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
      };
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
    });
    set(50);
  });

  /* ===== JOURNEYS TABS — click + auto-rotate with progress bar ===== */
  const jTabs = Array.from(document.querySelectorAll('.j-tab'));
  const jPanels = Array.from(document.querySelectorAll('.j-panel'));
  if (jTabs.length && jPanels.length) {
    const journeysSection = document.querySelector('.journeys');
    let jIndex = jTabs.findIndex(t => t.classList.contains('is-active'));
    if (jIndex < 0) jIndex = 0;
    let jTimer = null;
    const ROTATE_MS = 3000;

    const showJourney = (i) => {
      jIndex = (i + jTabs.length) % jTabs.length;
      const key = jTabs[jIndex].getAttribute('data-tab');
      jTabs.forEach(t => t.classList.toggle('is-active', t === jTabs[jIndex]));
      jPanels.forEach(p => p.classList.toggle('is-active', p.getAttribute('data-panel') === key));
      // Restart the progress-fill CSS animation on the newly active tab
      const fill = jTabs[jIndex].querySelector('.j-tab-fill');
      if (fill) {
        fill.style.animation = 'none';
        void fill.offsetWidth; // force reflow
        fill.style.animation = '';
      }
    };

    const startAuto = () => {
      stopAuto();
      // Restart progress fill on the currently active tab to sync with timer
      const fill = jTabs[jIndex].querySelector('.j-tab-fill');
      if (fill) {
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      }
      jTimer = setInterval(() => showJourney(jIndex + 1), ROTATE_MS);
    };
    const stopAuto = () => {
      if (jTimer) { clearInterval(jTimer); jTimer = null; }
    };

    // Manual clicks restart the cycle from clicked tab
    jTabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        showJourney(i);
        startAuto(); // restart timer so next auto-advance happens 5s after manual click
      });
    });

    // Pause auto-rotate while hovering the section (so users can read)
    if (journeysSection) {
      journeysSection.addEventListener('mouseenter', stopAuto);
      journeysSection.addEventListener('mouseleave', startAuto);
    }

    // Pause when tab is hidden, resume when visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAuto();
      else startAuto();
    });

    startAuto();
  }
});


/* ===== Grafted: kept inline search + predictive dropdown (not in V2) ===== */
document.addEventListener('DOMContentLoaded', function () {
/* ===== HEADER INLINE SEARCH (animated open, no separate page) ===== */
  const searchToggle = document.querySelector('.ha-search-toggle');
  const searchPanel = document.getElementById('HeaderSearch');
  if (searchToggle && searchPanel) {
    const searchHeader = searchToggle.closest('.site-header');
    const searchInput = searchPanel.querySelector('.header-search-input');
    const searchClose = searchPanel.querySelector('.header-search-close');
    const searchForm = searchPanel.querySelector('.header-search-form');

    const isSearchOpen = () => searchHeader && searchHeader.classList.contains('search-open');
    const openSearch = () => {
      if (!searchHeader) return;
      searchHeader.classList.add('search-open');
      searchToggle.classList.add('is-open');
      searchToggle.setAttribute('aria-expanded', 'true');
      searchPanel.setAttribute('aria-hidden', 'false');
      if (searchInput) setTimeout(() => searchInput.focus(), 130);
    };
    const closeSearch = () => {
      if (!searchHeader) return;
      searchHeader.classList.remove('search-open');
      searchToggle.classList.remove('is-open');
      searchToggle.setAttribute('aria-expanded', 'false');
      searchPanel.setAttribute('aria-hidden', 'true');
    };

    searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      isSearchOpen() ? closeSearch() : openSearch();
    });
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    // Close on Escape (return focus to the toggle)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isSearchOpen()) {
        closeSearch();
        searchToggle.focus();
      }
    });
    // Close when clicking outside the open panel
    document.addEventListener('click', (e) => {
      if (isSearchOpen() && !searchPanel.contains(e.target) && !searchToggle.contains(e.target)) {
        closeSearch();
      }
    });
    // Never submit an empty query
    if (searchForm) {
      searchForm.addEventListener('submit', (e) => {
        if (!searchInput || searchInput.value.trim() === '') {
          e.preventDefault();
          if (searchInput) searchInput.focus();
        }
      });
    }
  }

  /* ===== STICKY-NAV INLINE SEARCH (mirrors the header search) ===== */
  (function () {
    const tog = document.querySelector('.sticky-search-toggle');
    const panel = document.getElementById('StickySearch');
    const sticky = document.querySelector('.sticky-nav');
    if (!tog || !panel || !sticky) return;
    const input = panel.querySelector('.header-search-input');
    const closeBtn = panel.querySelector('.header-search-close');
    const form = panel.querySelector('.header-search-form');
    const isOpen = () => sticky.classList.contains('search-open');
    const open = () => { sticky.classList.add('search-open'); tog.classList.add('is-open'); tog.setAttribute('aria-expanded', 'true'); panel.setAttribute('aria-hidden', 'false'); if (input) setTimeout(() => input.focus(), 130); };
    const close = () => { sticky.classList.remove('search-open'); tog.classList.remove('is-open'); tog.setAttribute('aria-expanded', 'false'); panel.setAttribute('aria-hidden', 'true'); };
    tog.addEventListener('click', (e) => { e.preventDefault(); isOpen() ? close() : open(); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen()) { close(); tog.focus(); } });
    document.addEventListener('click', (e) => { if (isOpen() && !panel.contains(e.target) && !tog.contains(e.target)) close(); });
    if (form) form.addEventListener('submit', (e) => { if (!input || input.value.trim() === '') { e.preventDefault(); if (input) input.focus(); } });
  })();

  /* ===== PREDICTIVE SEARCH (live suggestions as you type) ===== */
  (function () {
    const psInputs = document.querySelectorAll('[data-predictive-input]');
    if (!psInputs.length) return;

    const esc = (s) => (s == null ? '' : String(s)).replace(/[&<>"']/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    psInputs.forEach((input) => {
      const wrap = input.closest('[data-predictive-wrapper]');
      if (!wrap) return;
      const box = wrap.querySelector('[data-predictive-results]');
      if (!box) return;
      const suggestUrl = wrap.getAttribute('data-predictive-url') || '/search/suggest';
      const searchUrl = wrap.getAttribute('data-search-url') || '/search';

      let timer = null, lastQ = '', controller = null, opts = [], active = -1;

      const close = () => { box.hidden = true; box.innerHTML = ''; opts = []; active = -1; };
      const sync = () => { opts = Array.from(box.querySelectorAll('a')); active = -1; };
      const setActive = (i) => {
        if (!opts.length) return;
        opts.forEach((el) => el.classList.remove('is-active'));
        active = (i + opts.length) % opts.length;
        opts[active].classList.add('is-active');
        opts[active].scrollIntoView({ block: 'nearest' });
      };

      const render = (q, data) => {
        const r = (data && data.resources && data.resources.results) || {};
        const groups = [
          { label: 'Suggestions', items: r.queries || [], type: 'query' },
          { label: 'Pages', items: r.pages || [], type: 'page' },
          { label: 'Articles', items: r.articles || [], type: 'article' },
          { label: 'Products', items: r.products || [], type: 'product' }
        ];
        let html = '';
        groups.forEach((g) => {
          if (!g.items.length) return;
          html += '<ul class="ps-group"><li class="ps-group__label">' + g.label + '</li>';
          g.items.slice(0, g.type === 'product' ? 5 : 4).forEach((it) => {
            if (g.type === 'query') {
              html += '<li><a class="ps-item ps-item--query" href="' + esc(it.url) + '"><span class="ps-q-icon" aria-hidden="true">&#8599;</span><span class="ps-item__text"><span class="ps-item__title">' + esc(it.text) + '</span></span></a></li>';
            } else {
              const imgUrl = (it.featured_image && it.featured_image.url) ? it.featured_image.url : (it.image || '');
              const thumb = imgUrl ? '<img class="ps-item__thumb" src="' + esc(imgUrl) + '" alt="" width="44" height="44" loading="lazy">' : '';
              html += '<li><a class="ps-item" href="' + esc(it.url) + '">' + thumb + '<span class="ps-item__text"><span class="ps-item__title">' + esc(it.title) + '</span></span></a></li>';
            }
          });
          html += '</ul>';
        });
        if (!html) {
          html = '<div class="ps-empty">No quick matches for &ldquo;' + esc(q) + '&rdquo;. Press Enter to search.</div>';
        } else {
          html += '<a class="ps-all" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '"><span>See all results for &ldquo;' + esc(q) + '&rdquo;</span><span aria-hidden="true">&rarr;</span></a>';
        }
        box.innerHTML = html;
        box.hidden = false;
        sync();
      };

      const run = (q) => {
        if (controller) controller.abort();
        controller = new AbortController();
        const url = suggestUrl + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=query,product,page,article&resources[limit]=5&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal })
          .then((res) => (res.ok ? res.json() : null))
          .then((data) => { if (data && input.value.trim() === q) render(q, data); })
          .catch(() => {});
      };

      input.addEventListener('input', () => {
        const q = input.value.trim();
        if (q.length < 2) { close(); lastQ = ''; return; }
        if (q === lastQ) return;
        lastQ = q;
        clearTimeout(timer);
        timer = setTimeout(() => run(q), 220);
      });

      input.addEventListener('keydown', (e) => {
        if (box.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
        else if (e.key === 'Enter') {
          if (active >= 0 && opts[active]) { e.preventDefault(); window.location.href = opts[active].getAttribute('href'); }
        } else if (e.key === 'Escape') { close(); e.stopPropagation(); }
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && box.innerHTML) box.hidden = false;
      });

      document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) close(); });
    });
  })();
});

/* ===== GHL LEAD RELAY — copy every Shopify contact-form submission into GoHighLevel ===== */
/* Forms are left exactly as-is. Fires only when the "GHL inbound webhook URL" setting is filled.
   Uses sendBeacon (form-encoded) so there's no CORS preflight and the POST survives the page reload. */
document.addEventListener('DOMContentLoaded', function () {
  var hook = (window.LOISELLE_GHL_HOOK || '').trim();
  if (!hook || !navigator.sendBeacon) return;
  document.querySelectorAll('form').forEach(function (f) {
    var ft = f.querySelector('input[name="form_type"]');
    if (!ft || ft.value !== 'contact') return; // only Shopify "contact" lead forms
    f.addEventListener('submit', function () {
      try {
        var data = new URLSearchParams(), n = 0;
        f.querySelectorAll('[name^="contact["]').forEach(function (el) {
          var v = (el.value || '').trim();
          if (v) { data.append(el.name.slice(8, -1), v); n++; } // contact[email] -> email
        });
        if (!n) return;
        var loc = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en';
        data.append('form_name', f.id === 'consult-form' ? 'Consultation' : f.id === 'quote-form' ? 'Contact / Quote' : 'Website form');
        data.append('locale', loc);                                  // en | fr
        data.append('language', loc === 'fr' ? 'Français' : 'English'); // human-readable
        data.append('source', 'loiselle.com' + location.pathname);
        navigator.sendBeacon(hook, data);
      } catch (e) {}
      /* no preventDefault — the Shopify form still submits (email backup + success page) */
    });
  });
});

/* ===== After a form submit reloads the page, bring the thank-you / error message into view ===== */
/* The storefront sets html{scroll-behavior:smooth} + body{overflow-x:hidden}, which silently cancels a
   smooth scrollIntoView fired before images settle the layout, and Shopify's success redirect drops the
   form's URL anchor. So we scroll the window directly (smooth off, after layout) to the SAME anchors that
   scroll correctly when typed by hand, and write that anchor back into the URL:
     #form-success  -> contact thank-you box
     #ghl-embed     -> consultation wrapper (stays correct even after a real GHL embed replaces the fallback)
     .form-errors   -> validation errors */
(function () {
  function findTarget() {
    var fs = document.getElementById('form-success');                       // contact success
    if (fs) return fs;
    if (document.querySelector('.ghl-success'))                             // consultation fallback success
      return document.getElementById('ghl-embed') || document.querySelector('.ghl-success');
    return document.querySelector('.form-errors');                          // validation errors
  }
  if (!findTarget()) return; // only present after a submit (success or validation error)
  /* On a tall page (contact: success at ~1836px) the browser's automatic scroll-restoration snaps back to
     the top during load and beats a single scroll. Disable it, then re-assert the scroll a few times across
     the load-settle window — but stop the instant the visitor scrolls themselves, so we never fight them. */
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
  var userMoved = false;
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, function () { userMoved = true; }, { passive: true, once: true });
  });
  function bringIntoView() {
    if (userMoved) return;
    var el = findTarget();
    if (!el) return;
    var top = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - 150); // clear the ~126px overlay header
    var prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto'; // beat html{scroll-behavior:smooth} so it lands instantly
    window.scrollTo(0, top);
    document.documentElement.style.scrollBehavior = prev;
    if (el.id && location.hash !== '#' + el.id) {
      try { history.replaceState(null, '', location.pathname + location.search + '#' + el.id); } catch (e) {}
    }
  }
  [0, 80, 200, 400, 700, 1100, 1600].forEach(function (d) { setTimeout(bringIntoView, d); });
  window.addEventListener('load', function () {
    setTimeout(function () {
      bringIntoView();
      if (!userMoved) { var el = findTarget(); if (el) { try { el.setAttribute('tabindex', '-1'); el.focus({ preventScroll: true }); } catch (e) {} } }
    }, 120);
  });
})();

/* ===== Custom file input — show selected file names in the page language ===== */
document.addEventListener('DOMContentLoaded', function () {
  var fr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  document.querySelectorAll('.ghl-file-input').forEach(function (input) {
    var wrap = input.closest('.ghl-file-wrap');
    var nameEl = wrap ? wrap.querySelector('.ghl-file-name') : null;
    if (!nameEl) return;
    input.addEventListener('change', function () {
      var n = input.files ? input.files.length : 0;
      if (n === 0) nameEl.textContent = fr ? 'Aucun fichier choisi' : 'No file chosen';
      else if (n === 1) nameEl.textContent = input.files[0].name;
      else nameEl.textContent = n + (fr ? ' fichiers sélectionnés' : ' files selected');
    });
  });
});
